<template>
    <div class="b-scheduler-container"></div>
</template>

<script>
// tslint:disable
import ruLocale from './ruLocale';

export default {

        name: 'scheduler',
    props: {
        // Configs
        autoHeight: Boolean,
        barMargin: {
            default: 2,
            type: Number
        },
        columns: Array,
        emptyText: String,
        eventBodyTemplate: Function,
        eventColor: {
            default: 'green',
            type: String
        },
        eventLayout: String,
        eventRenderer: Function,
        eventStyle: {
            default: 'plain',
            type: String
        },
        endDate: Date,
        fillTicks: Boolean,
        forceFit: {
            default: false,
            type: Boolean
        },
        hideHeaders: Boolean,
        id: String,
        milestoneCharWidth: Number,
        milestoneLayoutMode: String,
        multiEventSelect: Boolean,
        readOnly: Boolean,
        responsiveLevels: {
            default: undefined,
            type: Object
        },
        rowHeight: Number,
        showRemoveEventInContextMenu: Boolean,
        showRemoveRowInContextMenu: Boolean,
        showUnassignEventInContextMenu: Boolean,
        startDate: Date,
        viewPreset: {
            default: 'hourAndDay',
            type: [String, Object]
        },
        displayDateFormat: String,
        flex: String,
        height: [Number, String],
        listeners: Object,
        maxHeight: [Number, String],
        maxWidth: [Number, String],
        maxZoomLevel: Number,
        minHeight: [Number, String],
        minWidth: [Number, String],
        minZoomLevel: Number,
        partner: [Object, String],
        resourceTimeRanges: Array,
        scrollLeft: Number,
        scrollTop: Number,
        selectedEvents: Array,
        snap: Boolean,
        tickWidth: Number,
        timeResolution: Object,
        viewportCenterDate: Date,
        width: [Number, String],
        zoomLevel: Number,
        features: Object,
        locale: String,

        // Stores
        assignmentStore: Object,
        dependencyStore: Object,
        eventStore: Object,
        resourceStore: Object,

        crudManager: Object,

        // Data
        assignments: Array,
        dependencies: Array,
        events: Array,
        resources: Array,
        timeRanges: Array,

        config: Object,

        // Features, only used for initialization
        cellEditFeature: { type: [Boolean, Object], default: true },
        cellTooltipFeature: [Boolean, Object],
        columnDragToolbarFeature: [Boolean, Object],
        columnLinesFeature: { type: Boolean, default: true },
        columnPickerFeature: [Boolean, Object],
        columnReorderFeature: [Boolean, Object],
        columnResizeFeature: [Boolean, Object],
        contextMenuFeature: [Boolean, Object],
        dependenciesFeature: [Boolean, Object],
        dependencyEditFeature: [Boolean, Object],
        dependencyEditFeature: [Boolean, Object],
        eventContextMenuFeature: { type: [Boolean, Object], default: true },
        eventDragCreateFeature: { type: [Boolean, Object], default: true },
        eventDragFeature: { type: [Boolean, Object], default: true },
        eventEditFeature: { type: [Boolean, Object], default: true },
        eventFilterFeature: { type: [Boolean, Object], default: true },
        eventResizeFeature: { type: [Boolean, Object], default: true },
        eventTooltipFeature: { type: [Boolean, Object], default: true },
        filterBarFeature: [Boolean, Object],
        filterFeature: [Boolean, Object],
        groupFeature: [Boolean, Object, String],
        groupSummaryFeature: [Boolean, Object],
        headerContextMenuFeature: { type: [Boolean, Object], default: true },
        labelsFeature: [Boolean, Object],
        nonWorkingTimeFeature: [Boolean, Object],
        panFeature: [Boolean, Object],
        quickFindFeature: [Boolean, Object],
        regionResizeFeature: Boolean,
        resourceTimeRangesFeature: [Boolean, Object],
        rowReorderFeature: Boolean,
        scheduleContextMenuFeature: [Boolean, Object],
        scheduleTooltipFeature: { type: [Boolean, Object], default: true },
        searchFeature: [Boolean, Object],
        sortFeature: [Boolean, Object, String, Array],
        stripeFeature: Boolean,
        summaryFeature: [Boolean, Object],
        timeRangesFeature: { type: [Boolean, Object], default: true },
        treeFeature: [Boolean, Object]
        }, // eo props
        // runs after the component is attached to DOM (mounted)
        mounted() {

            const propKeys = Object.keys(this.$props),
                featureConfig = {};

            const config = {
                // Render grid to components element
                appendTo: this.$el,

                // Listeners, will relay events using $emit
                listeners: {
                    catchAll(event) {
                        // Uncomment this line to log events being emitted to console
                        //console.log(event.type);
                        this.$emit(event.type, event);
                    },

                    thisObj: this
                },

                //features : featureConfig
            };

            // Apply all props to grid config
            propKeys.forEach(prop => {
                if (prop.indexOf('Feature') > -1) {
                    const featureName = prop.substr(0, prop.length - 'Feature'.length);
                    // Prop is a feature config
                    featureConfig[featureName] = this[prop];
                } else {
                    if (prop === 'config') {
                        // Prop is a config object
                        Object.assign(config, this[prop]);
                    } else {
                        // Prop is a config
                        if (this[prop] !== undefined) {
                            config[prop] = this[prop]; }

                        // Set up a watcher
                        this.$watch(prop, newValue => {
                            this.schedulerEngine[prop] = Array.isArray(newValue) ? newValue.slice() : newValue;
                        });
                    }
                }
            }, this);

            const promise = new Promise(resolve => {
                if (!document.getElementById('bryntum')) {
                    const style = document.createElement('link');
                    style.rel = 'stylesheet';
                    style.href = process.env.BASE_URL + 'scheduler.stockholm.min.css';
                    style.id = 'bryntum-theme';

                    const plugin = document.createElement('script');
                    plugin.src = process.env.BASE_URL + 'scheduler.umd.min.js';
                    plugin.id = 'bryntum';
                    plugin.onload = () => resolve();
                    document.head.appendChild(style);
                    document.head.appendChild(plugin);
                } else {
                    return resolve();
                }
            });

            promise.then(() => {
                // Create a Bryntum Grid with props as configs
                const engine = this.schedulerEngine = new bryntum.scheduler.Scheduler(config);

                engine.eventStore && engine.eventStore.relayAll(engine, 'events');
                engine.resourceStore && engine.resourceStore.relayAll(engine, 'resources');
                engine.assignmentStore && engine.assignmentStore.relayAll(engine, 'assignments');
                engine.dependencyStore && engine.dependencyStore.relayAll(engine, 'dependencies');

                // Add 'Ru' locale
                engine.localeManager.registerLocale('Ru', {
                    desc: ruLocale.localDesc,
                    locale : ruLocale.locale
                });

                // Add 'Ru' locale for GPN
                engine.localeManager.registerLocale('gpn', {
                    desc: 'GPN',
                    locale : ruLocale.locale
                });

                engine.localeManager.locale = this.locale;
            });
    },
    // cleanup before destroy
    beforeDestroy() {
        // Make sure Bryntum Grid is destroyed when vue component is
        this.schedulerEngine.destroy();
    }
};
</script>
